import { render, staticRenderFns } from "./uploadBtn.vue?vue&type=template&id=968638a0&scoped=true&"
import script from "./uploadBtn.vue?vue&type=script&lang=js&"
export * from "./uploadBtn.vue?vue&type=script&lang=js&"
import style0 from "./uploadBtn.vue?vue&type=style&index=0&id=968638a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "968638a0",
  null
  
)

component.options.__file = "uploadBtn.vue"
export default component.exports